import '../sass/app.scss';

var navactive = false;

$('.burger').click(function(){
    if(navactive == false){
        $('.burger').addClass('active');
        $('.nav').addClass('active');
        navactive = true;
    } else {
        $('.burger').removeClass('active');
        $('.nav').removeClass('active');
        navactive = false;
    }
})


// WEBPACK FOOTER //
// ./assets/js/theme.js